/*
 * Copyright (c) 2019
 *    Reliant Business Valuation, LLC - http://reliantvalue.com
 *    Author: Xaero Zero - xaerozero@icloud.com
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { AuthProvider } from '../../../providers';
import { Router, ActivatedRoute } from '@angular/router';
import { User } from 'src/app/model';
import { CrmAlertComponent } from '../../fields';
import { LogService } from 'src/app/services';

@Component({
  selector: 'page-register',
  templateUrl: 'register.page.html',
  styleUrls: ['register.page.scss']
})
export class RegisterPage implements OnInit, OnDestroy {
  @ViewChild('alert') alert: CrmAlertComponent;
  registerForm: FormGroup;
  code: string;
  user: User;
  isCodeValid = true;

  constructor(
    private fb: FormBuilder,
    private authProvider: AuthProvider,
    private route: ActivatedRoute,
    private router: Router,
    private logService : LogService
  ) {

    this.registerForm = this.fb.group({
      USER_NAME_FIRST: [null, Validators.required],
      USER_NAME_LAST: [null, Validators.required],
      USER_PASSWORD: [null, Validators.compose([Validators.required, Validators.pattern('^(?=.*\\d)(?=.*[A-Z])(?=.*[a-z])[\\w~@#$%^&*+=`<>|{}:=’;!.?\\"()\\[\\]\\/-]{12,}$')])],
    });
  }

  ngOnDestroy(): void {

  }

  ngOnInit(): void {

    this.code = this.route.snapshot.queryParams['code'];

    if (!this.code) {
      this.isCodeValid = false;
    }

    this.authProvider.getUserByCode(this.code)
      .subscribe(response => {
        if (response.success) {
          this.isCodeValid = true;
          this.user = User.parse(response.result);
        } else {
          this.isCodeValid = false;
        }
      }, err => {
        this.logService.error(err);
      });
  }

  onRegisterSubmit(): void {
    this.alert.hide();

    if (this.registerForm.valid) {

      this.user.LAST_NAME = this.registerForm.value.USER_NAME_LAST;
      this.user.FIRST_NAME = this.registerForm.value.USER_NAME_FIRST;

      this.authProvider.register(this.user, this.code, this.registerForm.value.USER_PASSWORD)
        .subscribe(response => {

          if (response.success) {
            this.alert.showSuccess('You successfully registered.');

            this.registerForm.reset();

            setTimeout(() => {
              this.router.navigate(['/login']);
            }, 5000);
          } else {
            this.alert.show(response.error);
          }

        }, err => {
          this.logService.error(err);
        });
    }
  }

}
